module.exports = __webpack_public_path__ + "static/media/file-landscape.0a7c85cc.svg";